export interface PhotoAttributionData {
  provider: string;
  photographer: string;
  pageUrl: string | null;
}

interface PhotoAttributionProps {
  attribution: PhotoAttributionData | null | undefined;
  compact?: boolean;
}

const PROVIDER_LABELS: Record<string, string> = {
  pexels: 'Pexels',
  unsplash: 'Unsplash',
};

export function PhotoAttribution({ attribution, compact }: PhotoAttributionProps) {
  if (!attribution?.photographer || !attribution.provider) return null;

  const label = PROVIDER_LABELS[attribution.provider] || attribution.provider;
  const text = compact
    ? `${attribution.photographer} · ${label}`
    : `Photo : ${attribution.photographer} / ${label}`;

  if (attribution.pageUrl) {
    return (
      <a
        className={`photo-attribution${compact ? ' compact' : ''}`}
        href={attribution.pageUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {text}
      </a>
    );
  }

  return <span className={`photo-attribution${compact ? ' compact' : ''}`}>{text}</span>;
}
